export default {
  type: "light",
  primary: {
    c05: "hsla(251, 100%, 99%, 1)",
    c20: "hsla(251, 100%, 97%, 1)",
    c40: "hsla(249, 100%, 95%, 1)",
    c60: "hsla(250, 100%, 91%, 1)",
    c80: "hsla(249, 100%, 88%, 1)",
    c100: "hsla(248, 100%, 85%, 1)",
    c120: "hsla(248, 76%, 79%, 1)",
    c140: "hsla(247, 56%, 68%, 1)",
    c160: "hsla(247, 40%, 53%, 1)",
    c180: "hsla(247, 46%, 42%, 1)",
  },
  neutral: {
    c00: "hsla(0, 0%, 100%, 1)",
    c20: "hsla(0, 0%, 98%, 1)",
    c30: "hsla(0, 0%, 96%, 1)",
    c40: "hsla(0, 0%, 91%, 1)",
    c50: "hsla(0, 0%, 84%, 1)",
    c60: "hsla(0, 0%, 76%, 1)",
    c70: "hsla(0, 0%, 58%, 1)",
    c80: "hsla(0, 0%, 42%, 1)",
    c90: "hsla(0, 0%, 30%, 1)",
    c100: "hsla(0, 0%, 0%, 1)",
    c100a07: "hsla(0, 0%, 0%, 0.7)",
  },
  success: {
    c05: "hsla(120, 45%, 98%, 1)",
    c10: "hsla(109, 52%, 96%, 1)",
    c20: "hsla(109, 50%, 91%, 1)",
    c40: "hsla(110, 49%, 83%, 1)",
    c60: "hsla(110, 50%, 74%, 1)",
    c80: "hsla(110, 49%, 66%, 1)",
    c100: "hsla(110, 50%, 57%, 1)",
  },
  warning: {
    c05: "hsla(12, 100%, 98%, 1)",
    c10: "hsla(18, 100%, 96%, 1)",
    c20: "hsla(18, 100%, 92%, 1)",
    c40: "hsla(18, 100%, 84%, 1)",
    c60: "hsla(17, 100%, 76%, 1)",
    c80: "hsla(17, 100%, 71%, 1)",
    c100: "hsla(17, 100%, 60%, 1)",
  },
  error: {
    c05: "hsla(0, 80%, 98%, 1)",
    c10: "hsla(0, 89%, 96%, 1)",
    c20: "hsla(0, 84%, 93%, 1)",
    c40: "hsla(359, 84%, 85%, 1)",
    c60: "hsla(359, 84%, 77%, 1)",
    c80: "hsla(359, 84%, 70%, 1)",
    c100: "hsla(359, 84%, 63%, 1)",
  },
};
